import { newsList } from "@/mocks/chiGuaData";
import NewsCard from "./NewsCard";

export default function FreshSection() {
  const fresh = newsList.slice(0, 6);
  return (
    <section id="fresh" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/12 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-sun-line" aria-hidden="true"></i> 每日更新
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
              今日新鲜 · 不错过精彩
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              精选浏览推荐，聚合当下最值得一读的内容，让你轻松掌握新鲜事。
            </p>
          </div>
          <a
            href="#guide"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            了解更多 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {fresh.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}